import _styled from '@emotion/styled/base';
import { shorthandSpacingCss } from '../primitives/Spacer/index.js';

const List = _styled("ul", {
  target: "elmcmee0"
})(">li:last-child hr{display:none;}", shorthandSpacingCss, ";");

export { List };
